var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "line-content" },
    [
      _c("div", { staticClass: "flex-between" }, [
        _vm._m(0),
        _c(
          "div",
          { staticClass: "flex-align-center" },
          [
            _c(
              "div",
              { staticClass: "flex-align-center tag-list" },
              _vm._l(_vm.timeTagList, function (item, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    class: {
                      "list-tag-item": true,
                      "active-tag": _vm.tagIndex == index,
                    },
                    on: {
                      click: function ($event) {
                        _vm.tagIndex = index
                      },
                    },
                  },
                  [_vm._v("\n          " + _vm._s(item) + "\n        ")]
                )
              }),
              0
            ),
            _c("a-range-picker", {
              staticStyle: { width: "220px", margin: "0 15px" },
              attrs: {
                "allow-clear": false,
                getCalendarContainer: (node) => node.parentNode,
              },
              model: {
                value: _vm.dateRange,
                callback: function ($$v) {
                  _vm.dateRange = $$v
                },
                expression: "dateRange",
              },
            }),
            _c("j-dict-select-tag", {
              staticStyle: { width: "150px", "margin-right": "15px" },
              attrs: {
                placeholder: "请选择年级",
                dictCode:
                  "school_grade,grade_name,id,0=delete_flag order by sort_order",
                isShowEmpty: false,
              },
              on: {
                select: function ($event) {
                  return _vm.$set(_vm.queryParam, "classId", undefined)
                },
                clear: function ($event) {
                  return _vm.$set(_vm.queryParam, "classId", undefined)
                },
              },
              model: {
                value: _vm.queryParam.gradeId,
                callback: function ($$v) {
                  _vm.$set(_vm.queryParam, "gradeId", $$v)
                },
                expression: "queryParam.gradeId",
              },
            }),
            _c(
              "a-button",
              {
                attrs: { type: "primary" },
                on: {
                  click: function ($event) {
                    return _vm.getWeeklyReminderTrend(true)
                  },
                },
              },
              [_vm._v("查询")]
            ),
          ],
          1
        ),
      ]),
      _c("div", { staticStyle: { color: "#666", "margin-bottom": "10px" } }, [
        _vm._v(
          "\n    *\n    在这里可以查看每周的总提醒人数变化趋势，以便及时了解学校提醒人数的增加或减少的情况，做出相关管理干预\n  "
        ),
      ]),
      _vm.isShowChart
        ? _c("BarChart", {
            attrs: {
              height: "260px",
              showAvgBtn: "",
              grid: _vm.grid,
              fields: _vm.field,
              dataSource: _vm.dataSource,
              dataZoom: _vm.dataZoomConfig,
              legend: _vm.legend,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "flex-align-center" }, [
      _c("div", { staticClass: "title-2" }, [_vm._v("提醒人次变化趋势")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }